import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M21.7339 20.615L15.2379 14.097C16.2439 12.829 16.8499 11.226 16.8499 9.48295C16.8499 5.38796 13.5279 2.05396 9.44289 2.05396C5.35789 2.05396 2.03589 5.38595 2.03589 9.48295C2.03589 10.972 2.47289 12.408 3.30189 13.635C3.54189 13.993 4.02689 14.088 4.38189 13.846C4.73789 13.606 4.83189 13.122 4.59189 12.766C3.93889 11.795 3.59389 10.66 3.59389 9.48396C3.59389 6.24596 6.21789 3.61296 9.44289 3.61296C12.6679 3.61296 15.2919 6.24696 15.2919 9.48396C15.2919 12.722 12.6679 15.355 9.44289 15.355C8.48989 15.355 7.58289 15.133 6.74489 14.694C6.36589 14.495 5.89389 14.641 5.69489 15.023C5.49589 15.405 5.64289 15.874 6.02389 16.074C7.07089 16.622 8.25389 16.912 9.44389 16.912C11.2309 16.912 12.8719 16.274 14.1519 15.214L20.6319 21.715C20.7829 21.866 20.9839 21.943 21.1829 21.943C21.3819 21.943 21.5799 21.867 21.7329 21.715C22.0359 21.412 22.0369 20.919 21.7339 20.614V20.615Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'Search');

export default Icon;
